import client from './client';

/** Акция заведения для раздела «Доставка» (22.10.2026). Даты по Аксаю, YYYY-MM-DD. */
export interface PromoRow {
  id: number;
  venue: string;
  venue_name: string;
  venue_cover: string | null;
  title: string;
  subtitle: string | null;
  image_url: string | null;
  starts_on: string;
  ends_on: string | null;
  is_active: boolean;
  sort: number;
  /** live — идёт сегодня, planned — ещё не началась, ended — закончилась, off — выключена. */
  state: 'live' | 'planned' | 'ended' | 'off';
}

export interface PromoInput {
  venue: string;
  title: string;
  subtitle?: string | null;
  starts_on: string;
  ends_on?: string | null;
  is_active?: boolean;
}

export interface PromoPatch extends Partial<PromoInput> {
  clear_ends_on?: boolean;
}

const base = '/api/admin/delivery-promos';

export const deliveryPromosApi = {
  list: () => client.get<{ items: PromoRow[]; venues: { slug: string; name: string }[]; today: string }>(base),
  create: (data: PromoInput) => client.post<PromoRow>(base, data),
  update: (id: number, data: PromoPatch) => client.patch<PromoRow>(`${base}/${id}`, data),
  remove: (id: number) => client.delete(`${base}/${id}`),
  uploadImage: (id: number, file: File) => {
    const fd = new FormData();
    fd.append('file', file);
    return client.post<PromoRow>(`${base}/${id}/image`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  clearImage: (id: number) => client.delete<PromoRow>(`${base}/${id}/image`),
};
